<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#22cc61"
    :border="false"
    inactive-color="#6d6d6d"
    z-index="999"
    class="tabber_view"
  >
    <van-tabbar-item to="/Home">
      <span style="color:#1dc74a;">{{ $t('foorter.index') || '首页' }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/neww/zy1.png' : '/img/neww/zy1.png'" :alt="$t('foorter.index')" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Lottery">
      <span style="color:#1dc74a;">{{ $t('my.video_zone') || '影視專區' }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/neww/dt1.png' : '/img/neww/dt1.png'" :alt="$t('my.video_zone')" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Mine">
      <span style="color:#1dc74a;">{{ $t('my.personal_center') || '个人中心' }}</span>
      <template #icon="props">
        <img :src="props.active ? '/img/neww/wd1.png' : '/img/neww/wd1.png'" :alt="$t('my.personal_center')" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
    };
  },
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "Lottery") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 2;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "Lottery") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 2;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 120px;

.tabber_view {
  background-color: #151515;
  color:#1dc74a;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.van-tabbar {
  height: @tabbar-height;
}

.van-tabbar-item__icon img {
  height: 36px;
  margin-bottom: 10px;
}

.van-tabbar-item {
  font-size: 24px;
  color:#1dc74a;
}

::v-deep .van-tabbar-item--active {
  background-color: transparent;
  color:#1dc74a;
}
</style>
